import { render } from "./GlossaryOverview.vue?vue&type=template&id=5f6edca6&scoped=true"
import script from "./GlossaryOverview.vue?vue&type=script&lang=js"
export * from "./GlossaryOverview.vue?vue&type=script&lang=js"

import "./GlossaryOverview.vue?vue&type=style&index=0&id=5f6edca6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6edca6"]])

export default __exports__